<template>
  <div>
    <v-navigation-drawer
      persistent
      absolute
      disable-route-watcher
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="drawer"
      enable-resize-watcher
      app
    >
      <v-list>
        <v-list-tile
          value="true"
          v-for="(item, i) in items"
          :to="item.to"
          :key="i"
        >
          <v-list-tile-action>
            <v-icon v-html="item.icon"></v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar
      app
      fixed
      :clipped-left="clipped"
    >
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-btn icon @click.stop="miniVariant = !miniVariant" v-show="!getDevice.isMobile">
        <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
      </v-btn>
      <v-btn icon @click.stop="clipped = !clipped" v-show="!getDevice.isMobile">
        <v-icon>web</v-icon>
      </v-btn>
      <!-- <v-btn icon @click.stop="fixed = !fixed">
        <v-icon>remove</v-icon>
      </v-btn> -->
      <v-toolbar-title v-text="title"></v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- <v-btn icon @click.stop="rightDrawer = !rightDrawer">
        <v-icon>more_vert</v-icon>
      </v-btn> -->

      <div class="d-flex align-center" style="margin-left: auto">

        <div v-if="true">

          <v-menu
            offset-x
            :close-on-content-click="false"
            :nudge-width="200"
            bottom left
            v-model="menu"
          >
            <v-btn icon slot="activator" @click.native="show = !show">
              <v-badge :color="this.getTheme.color" v-model="show" left>
                <span slot="badge">3</span>
                <v-icon>notifications</v-icon>
              </v-badge>
            </v-btn>
            <v-layout row justify-center>
              <v-flex xs12>
              <v-card>
                <v-list>
                  <v-list-tile avatar>
                    <v-list-tile-avatar>
                      <img src="https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png" alt="Sptizer.io">
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title>{{ this.auth.auth.user.name }}</v-list-tile-title>
                      <v-list-tile-sub-title>Spitzer.io</v-list-tile-sub-title>
                    </v-list-tile-content>
                    <v-list-tile-action>
                      <v-btn
                        icon
                        :class="fav ? 'red--text' : ''"
                        @click="fav = !fav"
                      >
                        <v-icon>favorite</v-icon>
                      </v-btn>
                    </v-list-tile-action>
                  </v-list-tile>
                </v-list>
                <v-divider></v-divider>
                <v-list>
                  <v-list-tile>
                    <v-list-tile-action>
                      <v-switch v-model="message" :color="this.getTheme.color"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-title>Notificações</v-list-tile-title>
                  </v-list-tile>
                  <!-- <v-list-tile>
                    <v-list-tile-action>
                      <v-switch v-model="hints" color="purple"></v-switch>
                    </v-list-tile-action>
                    <v-list-tile-title>Enable hints</v-list-tile-title>
                  </v-list-tile> -->
                </v-list>

                <v-list two-line>
                  <template v-for="item in itemsNotification">
                    <v-subheader v-if="item.header" v-text="item.header"></v-subheader>
                    <v-divider v-else-if="item.divider" v-bind:inset="item.inset"></v-divider>
                    <v-list-tile avatar v-else v-bind:key="item.title" @click="">
                      <v-list-tile-avatar>
                        <img v-bind:src="item.avatar">
                      </v-list-tile-avatar>
                      <v-list-tile-content>
                        <v-list-tile-title v-html="item.title"></v-list-tile-title>
                        <v-list-tile-sub-title v-html="item.subtitle"></v-list-tile-sub-title>
                      </v-list-tile-content>
                    </v-list-tile>
                  </template>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <!-- <v-btn flat @click="menu = false">Cancel</v-btn> -->
                  <v-btn :color="this.getTheme.color" @click="menu = false" dark>Sair</v-btn>
                </v-card-actions>
              </v-card>
              </v-flex>
            </v-layout>
          </v-menu>

          <!-- <v-btn icon>
            <v-icon>view_module</v-icon>
          </v-btn> -->

          <v-menu bottom left>
            <v-btn icon slot="activator">
              <v-icon>more_vert</v-icon>
              <!-- <v-avatar size="32px" tile>
                <img src="https://storage.googleapis.com/spitzer-io/img/Logo%20Spitzer%20icone.png" alt="Sptizer.io">
              </v-avatar> -->
            </v-btn>
            <v-list>
              <v-list-tile v-for="item in menuItems" :key="item.title" :to="item.to">
                <v-list-tile-action>
                <v-icon v-html="item.icon"></v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title v-text="item.title" @click.prevent="actionMenu(item.action)"></v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
        <div v-else>
          <router-link to="/login">
            <v-btn icon>
              <v-icon>exit_to_app</v-icon>
            </v-btn>
          </router-link>
        </div>

      </div>

    </v-toolbar>

  </div>
</template>

<script>
import configWidgets from '../Widgets/config'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
export default {
  methods: {
    ...mapActions('auth', ['setSingOut']),
    actionMenu (value) {
      if (value === 'sair') {
        this.logout()
      } else if (value === 'profile') {
        this.$router.push('/profile')
      } else if (value === 'change-schedule') {
        this.$router.push('/change-schedule')
      }
    },
    logout () {
      this.setSingOut()
      this.$router.push('/auth/login')
    }
  },
  components: {
    configWidgets
  },
  computed: {
    ...mapGetters({
      customer: 'customer',
      auth: 'auth'
    }),
    ...mapGetters('schedule', ['getList', 'getAvailableAppointments']),
    ...mapGetters('app', ['getTheme', 'getDevice'])
  },
  data () {
    return {
      e2: 0,
      show: true,
      fav: true,
      menu: false,
      message: true,
      menuItems: [
        { title: 'Setor/Agenda', to: '/change-schedule', icon: 'shuffle', action: 'change-schedule' },
        { title: 'Perfil', to: '/profile', icon: 'account_circle', action: 'profile' },
        { title: 'Sair', to: '/auth/login', icon: 'exit_to_app', action: 'sair' }
      ],
      itemsNotification: [
        { header: moment().format('MMMM Do YYYY, h:mm a') },
        {
          avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
          title: 'Cadastro',
          subtitle: "<span class='grey--text text--darken-2'>Bem vindo</span> — Agora você poderá receber notificações"
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
          title: 'Agendamento <span class="grey--text text--lighten-1"></span>',
          subtitle: "<span class='grey--text text--darken-2'>Agendamento</span> — Melhor visualização do prontuário"
        },
        { divider: true, inset: true },
        {
          avatar: 'https://cdn1.iconfinder.com/data/icons/health-and-medical-glyps/128/8-512.png',
          title: 'Notícia',
          subtitle: "<span class='grey--text text--darken-2'>Consultor</span> — Consultor pessoal"
        }
      ],
      clipped: true,
      drawer: false,
      fixed: false,
      items: [
        {
          icon: 'today',
          title: 'Agenda',
          to: '/schedule'
        },
        {
          icon: 'dashboard',
          title: 'Dashboard',
          to: '/dashboard'
        },
        {
          icon: 'account_circle',
          title: 'Prontuário',
          to: '/patient'
        },
        {
          icon: 'phonelink_setup',
          title: 'Configurações',
          to: '/settings'
        }
      ],
      miniVariant: true,
      right: true,
      rightDrawer: false,
      title: 'MeuClinic'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/Toolbar.vue